import { computed, get } from '@ember/object';

export default function applyFunction(func, dependentKey) {
  return computed(dependentKey, function () {
    return func(get(this, dependentKey));
  });
}
